import React from 'react';
import ModalItem from '../Modal';
import UploadFile from '../UploadFile';
import MiniSpinner from '../MiniSpinner';
import ExcelFileTemplate from './ExcelFileTemplate';

export default function CardActualizacionMasiva({
  title = "Actualizar",
  btnText = "Actualizar",
  dataSet = [{}],
  isLoading,
  updateFile,
  exportExcel,
  isValidUpdateExcel,
  additionalHeader = undefined,
  children
}) {
  return (
    <div className="row align-items-center">

      <div className="col-12 col-md-auto mt-2"><h6><strong>{title}</strong></h6></div>

      <div className="col-12 col-md-auto">
        <ExcelFileTemplate dataSet={dataSet} />
      </div>

      {additionalHeader &&
        <div className="col-12 col-md-auto">
          {additionalHeader}
        </div>
      }

      <div className="col-8 col-md-12 my-3">
        <div className="row">
          <div className="col-auto">
            <label>Seleccionar archivo excel:</label>
          </div>
          <div className="col-auto col-md-12 text-md-center">
            <UploadFile
              acceptType={".xls, .xlsx"}
              inputId={title}
              onFileLoaded={updateFile}
            />
          </div>
        </div>
      </div>

      {children}

      <div className="form-horizontal form-material p-10">
        <div className="tab-content">
          <div className="row align-items-center justify-content-center">

            <div className="col-12 col-sm-auto" hidden={!isLoading}>
              <MiniSpinner />
            </div>

            <div className="col-12 col-sm-auto px-2">
              <ModalItem
                text={"¿" + btnText + "?"}
                disabled={isLoading}
                onDelete={exportExcel}
                validationHandler={isValidUpdateExcel}
                btnText={btnText}
                btnStyle="btn btn-sm background-rojo-megatone waves-light"
              />
            </div>

          </div>
        </div>
      </div>

    </div>
  )
}